import { makeAutoObservable } from 'mobx'
import { Item } from 'type/Item'

export class ItemsStore {
  private items = new Map<string, Item>()

  constructor() {
    makeAutoObservable(this)
  }

  add(item: Item) {
    const { item_id, external_item_id } = item
    this.items.set(item_id, item)
    if (external_item_id) this.items.set(external_item_id, item)
  }

  get(id: string): Item | undefined {
    return this.items.get(id)
  }
}

export const items = new ItemsStore()
